var map = {
	"./App": 83025,
	"./App.vue": 83025,
	"./assets/emails/email_bridge": 82725,
	"./assets/emails/email_bridge.js": 82725,
	"./assets/general/countries-to-income": 4024,
	"./assets/general/countries-to-income.json": 4024,
	"./assets/general/regions-to-countries": 1946,
	"./assets/general/regions-to-countries.json": 1946,
	"./assets/history": 27243,
	"./assets/history.json": 27243,
	"./assets/img/Arrow": 24951,
	"./assets/img/Arrow.vue": 24951,
	"./assets/img/ArrowDown": 96690,
	"./assets/img/ArrowDown.vue": 96690,
	"./assets/img/ArrowUp": 99774,
	"./assets/img/ArrowUp.vue": 99774,
	"./assets/img/close.svg": 48298,
	"./assets/img/full-screen.svg": 42154,
	"./assets/img/hyperlink.svg": 9220,
	"./assets/img/lock-orange.png": 65554,
	"./assets/img/lock.png": 4085,
	"./assets/img/online_only.png": 8632,
	"./assets/img/onsite+online.png": 31602,
	"./assets/img/pdf.svg": 39392,
	"./assets/img/recording.png": 33383,
	"./assets/img/unlocked-black.png": 43661,
	"./assets/img/unlocked.png": 62359,
	"./assets/img/wait.gif": 47992,
	"./assets/videos/showcases": 20888,
	"./assets/videos/showcases-spill": 87279,
	"./assets/videos/showcases-spill.json": 87279,
	"./assets/videos/showcases.json": 20888,
	"./assets/videos/showcases_previous": 45368,
	"./assets/videos/showcases_previous.json": 45368,
	"./assets/years/2010/People/Index": 36075,
	"./assets/years/2010/People/Index.vue": 36075,
	"./assets/years/2010/People/error": 91772,
	"./assets/years/2010/People/error.json": 91772,
	"./assets/years/2010/Program/Index": 61911,
	"./assets/years/2010/Program/Index.vue": 61911,
	"./assets/years/2011/People/Index": 62159,
	"./assets/years/2011/People/Index.vue": 62159,
	"./assets/years/2011/People/error": 12853,
	"./assets/years/2011/People/error.json": 12853,
	"./assets/years/2011/Program/Index": 72007,
	"./assets/years/2011/Program/Index.vue": 72007,
	"./assets/years/2012/People/Index": 49839,
	"./assets/years/2012/People/Index.vue": 49839,
	"./assets/years/2012/People/organizers": 87010,
	"./assets/years/2012/People/organizers.json": 87010,
	"./assets/years/2012/People/session-chairs": 56465,
	"./assets/years/2012/People/session-chairs.json": 56465,
	"./assets/years/2012/People/speakers": 22194,
	"./assets/years/2012/People/speakers.json": 22194,
	"./assets/years/2012/Program/Index": 56641,
	"./assets/years/2012/Program/Index.vue": 56641,
	"./assets/years/2012/Program/program": 20131,
	"./assets/years/2012/Program/program.json": 20131,
	"./assets/years/2013/People/Index": 54668,
	"./assets/years/2013/People/Index.vue": 54668,
	"./assets/years/2013/People/organizers": 64009,
	"./assets/years/2013/People/organizers.json": 64009,
	"./assets/years/2013/People/session-chairs": 31014,
	"./assets/years/2013/People/session-chairs.json": 31014,
	"./assets/years/2013/People/speakers": 77317,
	"./assets/years/2013/People/speakers.json": 77317,
	"./assets/years/2013/Program/Index": 63686,
	"./assets/years/2013/Program/Index.vue": 63686,
	"./assets/years/2013/Program/program": 37792,
	"./assets/years/2013/Program/program.json": 37792,
	"./assets/years/2014/People/Index": 44865,
	"./assets/years/2014/People/Index.vue": 44865,
	"./assets/years/2014/People/organizers": 42192,
	"./assets/years/2014/People/organizers.json": 42192,
	"./assets/years/2014/People/session-chairs": 32083,
	"./assets/years/2014/People/session-chairs.json": 32083,
	"./assets/years/2014/People/speakers": 35212,
	"./assets/years/2014/People/speakers.json": 35212,
	"./assets/years/2014/Program/Index": 53384,
	"./assets/years/2014/Program/Index.vue": 53384,
	"./assets/years/2014/Program/program": 37113,
	"./assets/years/2014/Program/program.json": 37113,
	"./assets/years/2015/People/Index": 90072,
	"./assets/years/2015/People/Index.vue": 90072,
	"./assets/years/2015/People/organizers": 70351,
	"./assets/years/2015/People/organizers.json": 70351,
	"./assets/years/2015/People/session-chairs": 59680,
	"./assets/years/2015/People/session-chairs.json": 59680,
	"./assets/years/2015/People/speakers": 82103,
	"./assets/years/2015/People/speakers.json": 82103,
	"./assets/years/2015/Program/Index": 50416,
	"./assets/years/2015/Program/Index.vue": 50416,
	"./assets/years/2015/Program/program": 80398,
	"./assets/years/2015/Program/program.json": 80398,
	"./assets/years/2016/People/Index": 17541,
	"./assets/years/2016/People/Index.vue": 17541,
	"./assets/years/2016/People/organizers": 38782,
	"./assets/years/2016/People/organizers.json": 38782,
	"./assets/years/2016/People/session-chairs": 845,
	"./assets/years/2016/People/session-chairs.json": 845,
	"./assets/years/2016/People/speakers": 82782,
	"./assets/years/2016/People/speakers.json": 82782,
	"./assets/years/2016/Program/Index": 12937,
	"./assets/years/2016/Program/Index.vue": 12937,
	"./assets/years/2016/Program/program": 67775,
	"./assets/years/2016/Program/program.json": 67775,
	"./assets/years/2017/People/Index": 24921,
	"./assets/years/2017/People/Index.vue": 24921,
	"./assets/years/2017/People/organizers": 30853,
	"./assets/years/2017/People/organizers.json": 30853,
	"./assets/years/2017/People/session-chairs": 40546,
	"./assets/years/2017/People/session-chairs.json": 40546,
	"./assets/years/2017/People/speakers": 59713,
	"./assets/years/2017/People/speakers.json": 59713,
	"./assets/years/2017/Program/Index": 71373,
	"./assets/years/2017/Program/Index.vue": 71373,
	"./assets/years/2017/Program/program": 27756,
	"./assets/years/2017/Program/program.json": 27756,
	"./assets/years/2018/People/Index": 12553,
	"./assets/years/2018/People/Index.vue": 12553,
	"./assets/years/2018/People/organizers": 84332,
	"./assets/years/2018/People/organizers.json": 84332,
	"./assets/years/2018/People/session-chairs": 62319,
	"./assets/years/2018/People/session-chairs.json": 62319,
	"./assets/years/2018/People/speakers": 75976,
	"./assets/years/2018/People/speakers.json": 75976,
	"./assets/years/2018/Program/Index": 22227,
	"./assets/years/2018/Program/Index.vue": 22227,
	"./assets/years/2018/Program/program": 45781,
	"./assets/years/2018/Program/program.json": 45781,
	"./assets/years/2019/Index": 30816,
	"./assets/years/2019/Index.vue": 30816,
	"./assets/years/2019/People/Index": 81915,
	"./assets/years/2019/People/Index.vue": 81915,
	"./assets/years/2019/People/organizers": 92267,
	"./assets/years/2019/People/organizers.json": 92267,
	"./assets/years/2019/People/session-chairs": 91276,
	"./assets/years/2019/People/session-chairs.json": 91276,
	"./assets/years/2019/People/speakers": 39843,
	"./assets/years/2019/People/speakers.json": 39843,
	"./assets/years/2019/Program/Index": 12227,
	"./assets/years/2019/Program/Index.vue": 12227,
	"./assets/years/2019/Program/program": 23098,
	"./assets/years/2019/Program/program.json": 23098,
	"./assets/years/2020/Index": 75452,
	"./assets/years/2020/Index.vue": 75452,
	"./assets/years/2020/People/Index": 14903,
	"./assets/years/2020/People/Index.vue": 14903,
	"./assets/years/2020/People/organizers": 29623,
	"./assets/years/2020/People/organizers.json": 29623,
	"./assets/years/2020/People/session-chairs": 53768,
	"./assets/years/2020/People/session-chairs.json": 53768,
	"./assets/years/2020/People/speakers": 73039,
	"./assets/years/2020/People/speakers.json": 73039,
	"./assets/years/2020/Program/Index": 22253,
	"./assets/years/2020/Program/Index.vue": 22253,
	"./assets/years/2020/Program/program": 29782,
	"./assets/years/2020/Program/program.json": 29782,
	"./assets/years/2020/Sponsors/Index": 98739,
	"./assets/years/2020/Sponsors/Index.vue": 98739,
	"./assets/years/2020/Sponsors/MainSponsor": 17752,
	"./assets/years/2020/Sponsors/MainSponsor.vue": 17752,
	"./assets/years/2020/Sponsors/img/Bridge-Gold+White.png": 65894,
	"./assets/years/2020/Sponsors/img/Bridge-Gold+White.svg": 42562,
	"./assets/years/2020/Sponsors/img/Bridge-Institute-background.png": 79856,
	"./assets/years/2020/Sponsors/img/Bridge-Institute-background.svg": 60804,
	"./assets/years/2020/Sponsors/img/Bridge-Institute-only.svg": 93806,
	"./assets/years/2020/Sponsors/img/Bridge-Institute-short.png": 50680,
	"./assets/years/2020/Sponsors/img/Bridge-Institute-short.svg": 50510,
	"./assets/years/2020/Sponsors/img/FBINF.png": 82455,
	"./assets/years/2020/Sponsors/img/Frontiers.png": 46288,
	"./assets/years/2020/Sponsors/img/ISCB.jpeg": 90124,
	"./assets/years/2020/Sponsors/img/PeerJ.png": 9128,
	"./assets/years/2020/img/Hero/Background.jpg": 63631,
	"./assets/years/2020/img/Hero/Large.jpg": 69426,
	"./assets/years/2020/img/Hero/Medium.jpg": 56346,
	"./assets/years/2021/Contact/Index": 57203,
	"./assets/years/2021/Contact/Index.vue": 57203,
	"./assets/years/2021/Index": 44559,
	"./assets/years/2021/Index.vue": 44559,
	"./assets/years/2021/People/Index": 13675,
	"./assets/years/2021/People/Index.vue": 13675,
	"./assets/years/2021/People/img/Ali_Erturk.png": 3136,
	"./assets/years/2021/People/img/Amos_Tanay.png": 24523,
	"./assets/years/2021/People/img/Andy_Yates.png": 30310,
	"./assets/years/2021/People/img/Anton_Petrov.png": 51634,
	"./assets/years/2021/People/img/Arvind_Pathak.png": 37187,
	"./assets/years/2021/People/img/Barbora_Kozlíková.png": 3581,
	"./assets/years/2021/People/img/Bjorn_Sommer.png": 10650,
	"./assets/years/2021/People/img/Daniel_Weiskopf.png": 51273,
	"./assets/years/2021/People/img/David_Goodsell.png": 98347,
	"./assets/years/2021/People/img/Fabian_de_Kok-Mercado.png": 14352,
	"./assets/years/2021/People/img/Inna_Boesselmann.png": 74659,
	"./assets/years/2021/People/img/Irmtraud_Meyer.png": 82716,
	"./assets/years/2021/People/img/James_Procter.png": 40705,
	"./assets/years/2021/People/img/Jessica_Xin_Hjaltelin.png": 39415,
	"./assets/years/2021/People/img/Kay_Nieselt.png": 7233,
	"./assets/years/2021/People/img/Kerstin_Howe.png": 58499,
	"./assets/years/2021/People/img/Kirsten_Bos.png": 30262,
	"./assets/years/2021/People/img/Lucy_Collinson.png": 91932,
	"./assets/years/2021/People/img/Lydia_Gregg.png": 1915,
	"./assets/years/2021/People/img/Léo_Guignard.png": 26751,
	"./assets/years/2021/People/img/Marc_A._Marti-Renom.png": 41078,
	"./assets/years/2021/People/img/Maria-Jesus_Martin.png": 72262,
	"./assets/years/2021/People/img/Nadia_Magnenat-Thalmann.png": 36370,
	"./assets/years/2021/People/img/Petra_Isenberg.png": 39413,
	"./assets/years/2021/People/img/Raili_Pall.png": 50092,
	"./assets/years/2021/People/img/Rob_Parton.png": 70169,
	"./assets/years/2021/People/img/Rosane_Minghim.png": 30905,
	"./assets/years/2021/People/img/Roser_Vento-Tormo.png": 19233,
	"./assets/years/2021/People/img/Sameer_Velankar.png": 76289,
	"./assets/years/2021/People/img/Seán_O'Donoghue.png": 76738,
	"./assets/years/2021/People/img/Silvio_Tosatto.png": 19368,
	"./assets/years/2021/People/img/Theodore_Alexandrov.png": 66030,
	"./assets/years/2021/People/img/Unknown.png": 15607,
	"./assets/years/2021/People/img/Yann_Ponty.png": 95552,
	"./assets/years/2021/People/img/Yannick_Schwab.png": 48317,
	"./assets/years/2021/People/organizers": 45976,
	"./assets/years/2021/People/organizers.json": 45976,
	"./assets/years/2021/People/session-chairs": 78715,
	"./assets/years/2021/People/session-chairs.json": 78715,
	"./assets/years/2021/People/speakers": 53092,
	"./assets/years/2021/People/speakers.json": 53092,
	"./assets/years/2021/Platform/Index": 92152,
	"./assets/years/2021/Platform/Index.vue": 92152,
	"./assets/years/2021/Posters/Index": 23708,
	"./assets/years/2021/Posters/Index.vue": 23708,
	"./assets/years/2021/Program/Index": 91133,
	"./assets/years/2021/Program/Index.vue": 91133,
	"./assets/years/2021/Program/program": 58945,
	"./assets/years/2021/Program/program.json": 58945,
	"./assets/years/2021/Registration/Index": 60964,
	"./assets/years/2021/Registration/Index.vue": 60964,
	"./assets/years/2021/Sponsors/Index": 68970,
	"./assets/years/2021/Sponsors/Index.vue": 68970,
	"./assets/years/2021/Sponsors/MainSponsor": 55788,
	"./assets/years/2021/Sponsors/MainSponsor.vue": 55788,
	"./assets/years/2021/Sponsors/VIZBI_Sponsorship-Brochure_virtual.pdf": 81852,
	"./assets/years/2021/Sponsors/img/AMI.png": 22630,
	"./assets/years/2021/Sponsors/img/BioVis.png": 7133,
	"./assets/years/2021/Sponsors/img/Bridge.png": 92962,
	"./assets/years/2021/Sponsors/img/Digizyme.png": 87337,
	"./assets/years/2021/Sponsors/img/Frontiers.png": 15859,
	"./assets/years/2021/Sponsors/img/ISCB.jpg": 25914,
	"./assets/years/2021/Sponsors/img/clarafi.png": 48119,
	"./assets/years/2021/Sponsors/img/embl.jpg": 1329,
	"./assets/years/2021/Sponsors/img/embl.png": 71929,
	"./assets/years/2021/Sponsors/img/embl.svg": 90543,
	"./assets/years/2021/img/Hero/Background.jpg": 87082,
	"./assets/years/2021/img/Hero/Large.jpg": 71745,
	"./assets/years/2021/img/Hero/Medium.jpg": 70999,
	"./assets/years/2022/Contact/Index": 33477,
	"./assets/years/2022/Contact/Index.vue": 33477,
	"./assets/years/2022/Index": 25521,
	"./assets/years/2022/Index.vue": 25521,
	"./assets/years/2022/Masterclass/Index": 29740,
	"./assets/years/2022/Masterclass/Index.vue": 29740,
	"./assets/years/2022/Masterclass/img/banner/hi_res.png": 29478,
	"./assets/years/2022/Masterclass/img/banner/low_res.jpg": 23663,
	"./assets/years/2022/People/Index": 10309,
	"./assets/years/2022/People/Index.vue": 10309,
	"./assets/years/2022/People/error": 79175,
	"./assets/years/2022/People/error.json": 79175,
	"./assets/years/2022/People/img/Alex_Jordan.png": 97645,
	"./assets/years/2022/People/img/Alex_Ritter.png": 37061,
	"./assets/years/2022/People/img/Ana_Crisan.png": 76881,
	"./assets/years/2022/People/img/Andrea_Schafferhans.png": 58902,
	"./assets/years/2022/People/img/Angela_Walker.png": 23509,
	"./assets/years/2022/People/img/Arzu_Çöltekin.png": 8143,
	"./assets/years/2022/People/img/Athma_Pai.png": 34756,
	"./assets/years/2022/People/img/Bang_Wong.png": 87218,
	"./assets/years/2022/People/img/Beata_Edyta_Mierzwa.png": 83951,
	"./assets/years/2022/People/img/Ben_Fry.png": 25263,
	"./assets/years/2022/People/img/Björn_Sommer.png": 63370,
	"./assets/years/2022/People/img/Bongshin_Lee.png": 23453,
	"./assets/years/2022/People/img/Bosco_Ho.png": 91388,
	"./assets/years/2022/People/img/Bree_Aldridge.png": 8619,
	"./assets/years/2022/People/img/Carl_Kesselman.png": 83526,
	"./assets/years/2022/People/img/Carlota_Casals copy.png": 76239,
	"./assets/years/2022/People/img/Carlota_Casals.png": 10070,
	"./assets/years/2022/People/img/Carolyn_Ott.png": 57332,
	"./assets/years/2022/People/img/Charles_Reilly.png": 50288,
	"./assets/years/2022/People/img/Christian_Stolte.png": 13779,
	"./assets/years/2022/People/img/Clodagh_O'Shea.png": 26356,
	"./assets/years/2022/People/img/Daniel_Haehn.png": 24406,
	"./assets/years/2022/People/img/Daniel_Janies.png": 44012,
	"./assets/years/2022/People/img/David_Aanensen.png": 93382,
	"./assets/years/2022/People/img/David_Goodsell.png": 46904,
	"./assets/years/2022/People/img/David_Shattuck.png": 67594,
	"./assets/years/2022/People/img/Devin_Sullivan.png": 41293,
	"./assets/years/2022/People/img/Drew_Berry.png": 79953,
	"./assets/years/2022/People/img/Eddie_Loh.png": 47419,
	"./assets/years/2022/People/img/Elizabeth_Brunk.png": 953,
	"./assets/years/2022/People/img/Emmanuel_Reynaud.png": 71723,
	"./assets/years/2022/People/img/Erez_Lieberman_Aiden.png": 27298,
	"./assets/years/2022/People/img/Eric_Lécuyer.png": 51529,
	"./assets/years/2022/People/img/Erik_Garrison.png": 76843,
	"./assets/years/2022/People/img/Gaël_McGill.png": 16336,
	"./assets/years/2022/People/img/Gokul_Upadhyayula.png": 96414,
	"./assets/years/2022/People/img/Hannah_Somhegyi.png": 37782,
	"./assets/years/2022/People/img/Hao_Li.png": 44924,
	"./assets/years/2022/People/img/Helen_Berman.png": 79302,
	"./assets/years/2022/People/img/Holly_Bik.png": 1835,
	"./assets/years/2022/People/img/Ivan_Viola.png": 27976,
	"./assets/years/2022/People/img/James_Michaelson.png": 10444,
	"./assets/years/2022/People/img/James_Procter.png": 72604,
	"./assets/years/2022/People/img/Jan_Kosinski.png": 57643,
	"./assets/years/2022/People/img/Jane_Richardson.png": 17312,
	"./assets/years/2022/People/img/Janet_Iwasa.png": 46372,
	"./assets/years/2022/People/img/Jian_Ma.png": 33567,
	"./assets/years/2022/People/img/John_Huddleston.png": 5560,
	"./assets/years/2022/People/img/Juri_Rappsilber.png": 98267,
	"./assets/years/2022/People/img/Kat_Holt.png": 6550,
	"./assets/years/2022/People/img/Kathi_Zarnack.png": 29646,
	"./assets/years/2022/People/img/Kathlynn_Alba.png": 99912,
	"./assets/years/2022/People/img/Kay_Nieselt.png": 96068,
	"./assets/years/2022/People/img/Kristin_Branson.png": 25826,
	"./assets/years/2022/People/img/Lawrence_Hunter.png": 7016,
	"./assets/years/2022/People/img/Loic_Royer.png": 60651,
	"./assets/years/2022/People/img/Loïc_Royer.png": 19041,
	"./assets/years/2022/People/img/Lydia_Gregg.png": 72026,
	"./assets/years/2022/People/img/Marc_Marti-Renom.png": 76329,
	"./assets/years/2022/People/img/Marcin_Imielinski.png": 66925,
	"./assets/years/2022/People/img/Martin_Krzywinski.png": 43281,
	"./assets/years/2022/People/img/Martin_Smith.png": 12751,
	"./assets/years/2022/People/img/Martina_Summer-Kutmon.png": 63597,
	"./assets/years/2022/People/img/Meghan_Driscoll.png": 4801,
	"./assets/years/2022/People/img/Michael_Joss.png": 30543,
	"./assets/years/2022/People/img/Michael_Krone.png": 23071,
	"./assets/years/2022/People/img/Michelle_Scott.png": 95087,
	"./assets/years/2022/People/img/Nadia_Magnenat_Thalmann.png": 89173,
	"./assets/years/2022/People/img/Nico_Scherf.png": 63291,
	"./assets/years/2022/People/img/Nils_Gehlenborg.png": 12054,
	"./assets/years/2022/People/img/Nils_Lindstrøm.png": 28610,
	"./assets/years/2022/People/img/Patrick_Chain.png": 91056,
	"./assets/years/2022/People/img/Richard_Neher.png": 45536,
	"./assets/years/2022/People/img/Richard_Smith.png": 94709,
	"./assets/years/2022/People/img/Richard_Weinberg.png": 6025,
	"./assets/years/2022/People/img/Rob_Beiko.png": 86862,
	"./assets/years/2022/People/img/Ruth_West.png": 60159,
	"./assets/years/2022/People/img/Sabrina_de_A._Silveira.png": 88732,
	"./assets/years/2022/People/img/Sameer_Velankar.png": 44660,
	"./assets/years/2022/People/img/Sara_Sandin.png": 5269,
	"./assets/years/2022/People/img/Sarah_Harris.png": 39051,
	"./assets/years/2022/People/img/Scooter_Morris.png": 9830,
	"./assets/years/2022/People/img/Scott_Fraser.png": 21335,
	"./assets/years/2022/People/img/Seán_O'Donoghue.png": 4015,
	"./assets/years/2022/People/img/Simon_Hayward.png": 84295,
	"./assets/years/2022/People/img/Speakers.jpg": 95484,
	"./assets/years/2022/People/img/Speakers.png": 440,
	"./assets/years/2022/People/img/Speakers_hi_res.png": 5395,
	"./assets/years/2022/People/img/Stefan_Bruckner.png": 45970,
	"./assets/years/2022/People/img/Steve_Pieper.png": 39929,
	"./assets/years/2022/People/img/Ting_Wang.png": 89070,
	"./assets/years/2022/People/img/Unknown.png": 31314,
	"./assets/years/2022/People/img/Unknown0.png": 39176,
	"./assets/years/2022/People/img/Uwe_Ohler.png": 89814,
	"./assets/years/2022/People/img/Virginie_Uhlmann.png": 28309,
	"./assets/years/2022/People/img/Yoseph_Barash.png": 37830,
	"./assets/years/2022/People/img/Yuko_Mimori-Kiyosue.png": 624,
	"./assets/years/2022/People/organizers": 11693,
	"./assets/years/2022/People/organizers.json": 11693,
	"./assets/years/2022/People/session-chairs": 30090,
	"./assets/years/2022/People/session-chairs.json": 30090,
	"./assets/years/2022/People/speakers": 43545,
	"./assets/years/2022/People/speakers.json": 43545,
	"./assets/years/2022/Platform/Index": 50953,
	"./assets/years/2022/Platform/Index.vue": 50953,
	"./assets/years/2022/Posters/Index": 70240,
	"./assets/years/2022/Posters/Index.vue": 70240,
	"./assets/years/2022/Program/Index": 74591,
	"./assets/years/2022/Program/Index.vue": 74591,
	"./assets/years/2022/Program/program": 84212,
	"./assets/years/2022/Program/program.json": 84212,
	"./assets/years/2022/Registration/Index": 13037,
	"./assets/years/2022/Registration/Index.vue": 13037,
	"./assets/years/2022/Sponsors/Index": 32789,
	"./assets/years/2022/Sponsors/Index.vue": 32789,
	"./assets/years/2022/Sponsors/MainSponsor": 23691,
	"./assets/years/2022/Sponsors/MainSponsor.vue": 23691,
	"./assets/years/2022/Sponsors/img/Bridge-Gold+White.png": 88804,
	"./assets/years/2022/Sponsors/img/Bridge-Gold+White.svg": 98292,
	"./assets/years/2022/Sponsors/img/Bridge-Institute-background.png": 86994,
	"./assets/years/2022/Sponsors/img/Bridge-Institute-background.svg": 12578,
	"./assets/years/2022/Sponsors/img/Bridge-Institute-only.svg": 9944,
	"./assets/years/2022/Sponsors/img/Bridge-Institute-short.png": 99254,
	"./assets/years/2022/Sponsors/img/Bridge-Institute-short.svg": 38472,
	"./assets/years/2022/Sponsors/img/FBINF.png": 39417,
	"./assets/years/2022/Sponsors/img/Frontiers.png": 64530,
	"./assets/years/2022/Sponsors/img/ISCB.jpeg": 93850,
	"./assets/years/2022/Sponsors/img/PeerJ.png": 49242,
	"./assets/years/2022/Workshop/Index": 50521,
	"./assets/years/2022/Workshop/Index.vue": 50521,
	"./assets/years/2022/Workshop/img/Medium.jpeg": 88178,
	"./assets/years/2022/img/Hero/Background.jpg": 2245,
	"./assets/years/2022/img/Hero/Large.jpg": 24936,
	"./assets/years/2022/img/Hero/Medium.jpg": 5740,
	"./assets/years/2023/Contact/Index": 37172,
	"./assets/years/2023/Contact/Index.vue": 37172,
	"./assets/years/2023/Index": 6141,
	"./assets/years/2023/Index.vue": 6141,
	"./assets/years/2023/Masterclass/Index": 53392,
	"./assets/years/2023/Masterclass/Index.vue": 53392,
	"./assets/years/2023/Masterclass/img/banner/Banner.001 copy 2.jpeg": 35144,
	"./assets/years/2023/Masterclass/img/banner/Banner.001 copy.jpeg": 75874,
	"./assets/years/2023/Masterclass/img/banner/Banner.001-full-size.jpeg": 58585,
	"./assets/years/2023/Masterclass/links": 6316,
	"./assets/years/2023/Masterclass/links.json": 6316,
	"./assets/years/2023/People/Index": 98283,
	"./assets/years/2023/People/Index.vue": 98283,
	"./assets/years/2023/People/img/Alex_Jordan.png": 77250,
	"./assets/years/2023/People/img/Alex_Ritter.png": 1662,
	"./assets/years/2023/People/img/Andrea_Schafferhans.png": 27773,
	"./assets/years/2023/People/img/Arzu_Çöltekin.png": 41736,
	"./assets/years/2023/People/img/Barbora_Kozlíková copy.png": 78624,
	"./assets/years/2023/People/img/Barbora_Kozlíková.png": 36807,
	"./assets/years/2023/People/img/Beata_Edyta_Mierzwa.png": 56920,
	"./assets/years/2023/People/img/Björn_Sommer.png": 10779,
	"./assets/years/2023/People/img/Christian_Stolte.png": 81642,
	"./assets/years/2023/People/img/Christian_Stolte1.png": 25337,
	"./assets/years/2023/People/img/Daniel_Haehn.png": 44719,
	"./assets/years/2023/People/img/Drew_Berry.png": 74304,
	"./assets/years/2023/People/img/Emmanuel_G._Reynaud.png": 83362,
	"./assets/years/2023/People/img/Erez_Lieberman_Aiden.png": 55655,
	"./assets/years/2023/People/img/Ivan_Viola.png": 14513,
	"./assets/years/2023/People/img/James_Procter.png": 26071,
	"./assets/years/2023/People/img/Joanna_Leng.png": 59785,
	"./assets/years/2023/People/img/Juri_Rappsilber.png": 48844,
	"./assets/years/2023/People/img/Kat_Holt.png": 70411,
	"./assets/years/2023/People/img/Kathi_Zarnack.png": 8317,
	"./assets/years/2023/People/img/Kay_Nieselt.png": 74067,
	"./assets/years/2023/People/img/Lawrence_Hunter.png": 18163,
	"./assets/years/2023/People/img/Lina_Kim.png": 35849,
	"./assets/years/2023/People/img/Marc_A._Marti-Renom.png": 91716,
	"./assets/years/2023/People/img/Martin_Dohrn.png": 35686,
	"./assets/years/2023/People/img/Martin_Smith.png": 74530,
	"./assets/years/2023/People/img/Martina_Summer-Kutmon.png": 7534,
	"./assets/years/2023/People/img/Maryann_Heck.png": 38789,
	"./assets/years/2023/People/img/Michael_Krone.png": 95908,
	"./assets/years/2023/People/img/Michelle_Scott.png": 49930,
	"./assets/years/2023/People/img/Nadia_Magnenat-Thalmann.png": 98472,
	"./assets/years/2023/People/img/Nathalie_Sneider.png": 31326,
	"./assets/years/2023/People/img/Neblina_Sikta.png": 70349,
	"./assets/years/2023/People/img/Nico_Scherf.png": 63248,
	"./assets/years/2023/People/img/Placeholder.png": 1128,
	"./assets/years/2023/People/img/Richard_Neher.png": 19599,
	"./assets/years/2023/People/img/Sabrina_de_A._Silveira.png": 51497,
	"./assets/years/2023/People/img/Sandeep_Kaur.png": 81377,
	"./assets/years/2023/People/img/Sarah_Anne_Harris.png": 60727,
	"./assets/years/2023/People/img/Seán_O'Donoghue.png": 29024,
	"./assets/years/2023/People/img/Sinem_Saka.png": 69664,
	"./assets/years/2023/People/img/Srigokul_Upadhyayula.png": 51401,
	"./assets/years/2023/People/img/Stefan_Bruckner.png": 50029,
	"./assets/years/2023/People/img/Unknown.png": 57033,
	"./assets/years/2023/People/img/Uwe_Ohler.png": 63497,
	"./assets/years/2023/People/img/Virginie_Uhlmann.png": 81176,
	"./assets/years/2023/People/img/Yuko_Mimori-Kiyosue.png": 62691,
	"./assets/years/2023/People/img/large/Alex_Jordan.jpg": 57766,
	"./assets/years/2023/People/img/large/Alex_Ritter.jpg": 23482,
	"./assets/years/2023/People/img/large/Arzu_Çöltekin.jpg": 62540,
	"./assets/years/2023/People/img/large/Barbora_Kozlíková.jpg": 1495,
	"./assets/years/2023/People/img/large/Christian_Stolte.jpg": 66510,
	"./assets/years/2023/People/img/large/Drew_Berry.jpg": 97540,
	"./assets/years/2023/People/img/large/Emmanuel_G._Reynaud.jpg": 47238,
	"./assets/years/2023/People/img/large/Erez_Lieberman_Aiden.jpg": 69015,
	"./assets/years/2023/People/img/large/Erez_Lieberman_Aiden_1.jpg": 18499,
	"./assets/years/2023/People/img/large/Erez_Lieberman_Aiden_2.jpg": 72436,
	"./assets/years/2023/People/img/large/Erez_Lieberman_Aiden_3.jpg": 60593,
	"./assets/years/2023/People/img/large/Ivan_Viola.jpg": 47913,
	"./assets/years/2023/People/img/large/Joanna_Leng.jpg": 8545,
	"./assets/years/2023/People/img/large/Juri_Rappsilber.jpg": 72552,
	"./assets/years/2023/People/img/large/Kathi_Zarnack.jpg": 34221,
	"./assets/years/2023/People/img/large/Lina_Kim.jpg": 95745,
	"./assets/years/2023/People/img/large/Marc_A._Marti-Renom.jpg": 69536,
	"./assets/years/2023/People/img/large/Martin_Dohrn.jpg": 80930,
	"./assets/years/2023/People/img/large/Martin_Smith.jpg": 62918,
	"./assets/years/2023/People/img/large/Martina_Summer-Kutmon.jpg": 84586,
	"./assets/years/2023/People/img/large/Michael_Krone.jpg": 54048,
	"./assets/years/2023/People/img/large/Nadia_Magnenat-Thalmann.jpg": 17292,
	"./assets/years/2023/People/img/large/Richard_Neher.jpg": 78335,
	"./assets/years/2023/People/img/large/Sabrina_de_A._Silveira.jpg": 73697,
	"./assets/years/2023/People/img/large/Sarah_Anne_Harris.jpg": 74695,
	"./assets/years/2023/People/img/large/Seán_O'Donoghue.jpg": 4068,
	"./assets/years/2023/People/img/large/Sinem_Saka.jpg": 28900,
	"./assets/years/2023/People/img/large/Stefan_Bruckner.jpg": 86461,
	"./assets/years/2023/People/img/large/Template.png": 97049,
	"./assets/years/2023/People/img/large/Unknown.jpg": 80513,
	"./assets/years/2023/People/img/large/Uwe_Ohler.jpg": 20833,
	"./assets/years/2023/People/img/large/Virginie_Uhlmann.jpg": 44284,
	"./assets/years/2023/People/img/large/Yuko_Mimori-Kiyosue.jpg": 63899,
	"./assets/years/2023/People/organizers": 8838,
	"./assets/years/2023/People/organizers.json": 8838,
	"./assets/years/2023/People/session-chairs": 8885,
	"./assets/years/2023/People/session-chairs.json": 8885,
	"./assets/years/2023/People/speakers": 71542,
	"./assets/years/2023/People/speakers.json": 71542,
	"./assets/years/2023/Posters/Index": 77242,
	"./assets/years/2023/Posters/Index.vue": 77242,
	"./assets/years/2023/Posters/img/AR-exhibit.jpg": 79311,
	"./assets/years/2023/Posters/img/IMG_7030.jpeg": 42355,
	"./assets/years/2023/Posters/img/IMG_7031.jpeg": 65676,
	"./assets/years/2023/Posters/img/IMG_7032.jpeg": 68557,
	"./assets/years/2023/Posters/img/IMG_7033.jpeg": 37222,
	"./assets/years/2023/Posters/img/IMG_7034.jpeg": 31055,
	"./assets/years/2023/Posters/img/IMG_7035.jpeg": 19512,
	"./assets/years/2023/Posters/img/IMG_7036.jpeg": 66905,
	"./assets/years/2023/Posters/img/Play-button.png": 27619,
	"./assets/years/2023/Posters/img/schol-ar+button.jpg": 9016,
	"./assets/years/2023/Posters/img/schol-ar+button.png": 92060,
	"./assets/years/2023/Posters/img/schol-ar.jpeg": 43884,
	"./assets/years/2023/Program/Index": 32223,
	"./assets/years/2023/Program/Index.vue": 32223,
	"./assets/years/2023/Program/program": 74343,
	"./assets/years/2023/Program/program.json": 74343,
	"./assets/years/2023/Registration/Index": 32825,
	"./assets/years/2023/Registration/Index.vue": 32825,
	"./assets/years/2023/Registration/fees": 95691,
	"./assets/years/2023/Registration/fees.json": 95691,
	"./assets/years/2023/Registration/img/invoice.png": 15992,
	"./assets/years/2023/Showcase/Index": 53335,
	"./assets/years/2023/Showcase/Index.vue": 53335,
	"./assets/years/2023/Showcase/img/banner.jpeg": 48992,
	"./assets/years/2023/Sponsors/Index": 3886,
	"./assets/years/2023/Sponsors/Index.vue": 3886,
	"./assets/years/2023/Sponsors/MainSponsor": 7174,
	"./assets/years/2023/Sponsors/MainSponsor.vue": 7174,
	"./assets/years/2023/Sponsors/img/CoB-white.png": 89763,
	"./assets/years/2023/Sponsors/img/CoB.png": 29763,
	"./assets/years/2023/Sponsors/img/CoB.svg": 18547,
	"./assets/years/2023/Sponsors/img/Digizyme.png": 15183,
	"./assets/years/2023/Sponsors/img/EG-white.png": 54571,
	"./assets/years/2023/Sponsors/img/EG.svg.png": 37811,
	"./assets/years/2023/Sponsors/img/EMBL_logo_colour_DIGITAL.png": 75419,
	"./assets/years/2023/Sponsors/img/EMBL_logo_white.png": 57355,
	"./assets/years/2023/Sponsors/img/EMBO-Reports.png": 77942,
	"./assets/years/2023/Sponsors/img/FBINF.png": 84418,
	"./assets/years/2023/Sponsors/img/Frontiers.png": 43573,
	"./assets/years/2023/Sponsors/img/ISCB.jpeg": 12629,
	"./assets/years/2023/Sponsors/img/PeerJ.png": 42861,
	"./assets/years/2023/Sponsors/img/Platano.svg": 18598,
	"./assets/years/2023/Sponsors/img/embl.jpg": 62627,
	"./assets/years/2023/Sponsors/img/embl.svg": 58149,
	"./assets/years/2023/Sponsors/img/embo-primary-black.jpg": 52175,
	"./assets/years/2023/Sponsors/img/embo-primary-black.png": 76223,
	"./assets/years/2023/Sponsors/img/embo-primary-black.svg": 7373,
	"./assets/years/2023/Sponsors/img/embo-primary-white.png": 61913,
	"./assets/years/2023/Sponsors/img/embo-primary-white.svg": 16851,
	"./assets/years/2023/Sponsors/img/embo-workshop copy.png": 61593,
	"./assets/years/2023/Sponsors/img/embo-workshop.png": 85188,
	"./assets/years/2023/Sponsors/img/iubmb.jpeg": 65055,
	"./assets/years/2023/Sponsors/img/rsob.png": 66361,
	"./assets/years/2023/Sponsors/img/rsob.svg": 98715,
	"./assets/years/2023/Sponsors/img/small/CoB.png": 71419,
	"./assets/years/2023/Sponsors/img/small/EG.svg.png": 86363,
	"./assets/years/2023/Sponsors/img/small/ISCB.jpeg": 24909,
	"./assets/years/2023/Sponsors/img/small/embl.jpg": 32379,
	"./assets/years/2023/Sponsors/img/small/embo-primary-black.jpg": 48407,
	"./assets/years/2023/VR/Index": 77998,
	"./assets/years/2023/VR/Index.vue": 77998,
	"./assets/years/2023/VR/img/banner.jpg": 3486,
	"./assets/years/2023/Venue/Index": 37868,
	"./assets/years/2023/Venue/Index.vue": 37868,
	"./assets/years/2023/Venue/helloworld.pdf": 9400,
	"./assets/years/2023/Venue/hotels": 66671,
	"./assets/years/2023/Venue/hotels.json": 66671,
	"./assets/years/2023/Venue/img/banner.jpeg": 97962,
	"./assets/years/2023/img/Assets/Banner.gif": 61304,
	"./assets/years/2023/img/Assets/IG-post.png": 31894,
	"./assets/years/2023/img/Assets/Poster.jpg": 36750,
	"./assets/years/2023/img/Assets/Poster.pdf": 61717,
	"./assets/years/2023/img/Assets/Poster.png": 68170,
	"./assets/years/2023/img/Assets/Twitter-Fb.png": 55595,
	"./assets/years/2023/img/Assets/holdingslide.jpg": 79209,
	"./assets/years/2023/img/Hero/BackgroundGradient.jpg": 46296,
	"./assets/years/2023/img/Hero/BackgroundNoGradient.jpg": 59929,
	"./assets/years/2023/img/Hero/Large.png": 49559,
	"./assets/years/2023/img/Hero/Medium.jpg": 16689,
	"./assets/years/2024/Contact/Index": 78895,
	"./assets/years/2024/Contact/Index.vue": 78895,
	"./assets/years/2024/Index": 44672,
	"./assets/years/2024/Index.vue": 44672,
	"./assets/years/2024/Masterclass/Index": 53117,
	"./assets/years/2024/Masterclass/Index.vue": 53117,
	"./assets/years/2024/Masterclass/links": 3193,
	"./assets/years/2024/Masterclass/links.json": 3193,
	"./assets/years/2024/People/Index": 81277,
	"./assets/years/2024/People/Index.vue": 81277,
	"./assets/years/2024/People/img/Ahna_Skop.png": 87726,
	"./assets/years/2024/People/img/Alex_McDowell.png": 78150,
	"./assets/years/2024/People/img/Alex_Ritter.png": 659,
	"./assets/years/2024/People/img/Alexander_Rose.png": 9640,
	"./assets/years/2024/People/img/Alison_Young.png": 90897,
	"./assets/years/2024/People/img/Anders_Ynnerman.png": 47818,
	"./assets/years/2024/People/img/Andrew_Moore.png": 46482,
	"./assets/years/2024/People/img/Barbora_Kozlíková.png": 19626,
	"./assets/years/2024/People/img/Beata_Edyta_Mierzwa.png": 87913,
	"./assets/years/2024/People/img/Charlie_Sheehan.png": 43001,
	"./assets/years/2024/People/img/Christian_Stolte.png": 5821,
	"./assets/years/2024/People/img/Corey_Stevens.png": 89121,
	"./assets/years/2024/People/img/David_Goodsell.png": 16686,
	"./assets/years/2024/People/img/David_Koes.png": 6771,
	"./assets/years/2024/People/img/Dmitry_Finkelberg.jpg": 81417,
	"./assets/years/2024/People/img/Dmitry_Finkelberg.png": 84113,
	"./assets/years/2024/People/img/Eddie_Loh.png": 6693,
	"./assets/years/2024/People/img/Fei_Zhang.png": 20701,
	"./assets/years/2024/People/img/Fiona_Naughton.png": 65896,
	"./assets/years/2024/People/img/Helen_Berman.png": 30776,
	"./assets/years/2024/People/img/Holly_Bik.png": 43653,
	"./assets/years/2024/People/img/James_Procter.png": 85034,
	"./assets/years/2024/People/img/Jane_Richardson.png": 44814,
	"./assets/years/2024/People/img/Jessica_Hullman.png": 79574,
	"./assets/years/2024/People/img/Karen_Miga.png": 20260,
	"./assets/years/2024/People/img/Katharina_Ribbeck.png": 22180,
	"./assets/years/2024/People/img/Katy_Börner.png": 35611,
	"./assets/years/2024/People/img/Lawrence_Hunter.png": 37582,
	"./assets/years/2024/People/img/Lisa_Delgado.png": 29288,
	"./assets/years/2024/People/img/Lorenzo_Casalino.png": 97586,
	"./assets/years/2024/People/img/Martin_Krzywinski.png": 31043,
	"./assets/years/2024/People/img/Martin_Smith.png": 45805,
	"./assets/years/2024/People/img/Matthew_Cooney.png": 91646,
	"./assets/years/2024/People/img/Matthew_Taliaferro.png": 38404,
	"./assets/years/2024/People/img/Nils_Lindström.png": 38066,
	"./assets/years/2024/People/img/Rachel_Meyer.png": 13454,
	"./assets/years/2024/People/img/Regina_Wetzer.png": 87178,
	"./assets/years/2024/People/img/Remo_Rohs.png": 61486,
	"./assets/years/2024/People/img/Scott_Fraser.png": 4741,
	"./assets/years/2024/People/img/Seán_O'Donoghue.png": 5149,
	"./assets/years/2024/People/img/Steven_Haddock.png": 55430,
	"./assets/years/2024/People/img/Theodoros_Soldatos.png": 63843,
	"./assets/years/2024/People/img/Unknown.png": 23868,
	"./assets/years/2024/People/img/Valentina_Pedoia.png": 30613,
	"./assets/years/2024/People/img/Wesley_Legant.png": 35103,
	"./assets/years/2024/People/img/large/Ahna_Skop.jpg": 41182,
	"./assets/years/2024/People/img/large/Alex_McDowell.jpg": 18145,
	"./assets/years/2024/People/img/large/Alexander_Ritter.jpg": 23635,
	"./assets/years/2024/People/img/large/Alison_Young.jpg": 99741,
	"./assets/years/2024/People/img/large/Anders_Ynnerman.jpg": 98050,
	"./assets/years/2024/People/img/large/Barbora_Kozlíková.jpg": 50674,
	"./assets/years/2024/People/img/large/Charlie_Sheehan.jpg": 56461,
	"./assets/years/2024/People/img/large/Christian_Stolte.jpg": 91809,
	"./assets/years/2024/People/img/large/Corey_Stevens.jpg": 79813,
	"./assets/years/2024/People/img/large/David_Goodsell.jpg": 80150,
	"./assets/years/2024/People/img/large/David_Koes.jpg": 56927,
	"./assets/years/2024/People/img/large/Fei_Zhang.jpg": 82318,
	"./assets/years/2024/People/img/large/Fiona_Naughton.jpg": 19792,
	"./assets/years/2024/People/img/large/Jane_Richardson.jpg": 6582,
	"./assets/years/2024/People/img/large/Jessica_Hullman.jpg": 67094,
	"./assets/years/2024/People/img/large/Karen_Miga.jpg": 42812,
	"./assets/years/2024/People/img/large/Katy_Börner.jpg": 43543,
	"./assets/years/2024/People/img/large/Lorenzo_Casalino.jpg": 83378,
	"./assets/years/2024/People/img/large/Martin_Krzywinski.jpg": 83063,
	"./assets/years/2024/People/img/large/Martin_Smith.jpg": 24673,
	"./assets/years/2024/People/img/large/Matthew_Taliaferro.jpg": 20988,
	"./assets/years/2024/People/img/large/Rachel_Meyer.jpg": 29294,
	"./assets/years/2024/People/img/large/Regina_Wetzer.jpg": 96746,
	"./assets/years/2024/People/img/large/Remo_Rohs.jpg": 36094,
	"./assets/years/2024/People/img/large/Scott_Fraser.jpg": 84441,
	"./assets/years/2024/People/img/large/Seán_O'Donoghue.jpg": 10905,
	"./assets/years/2024/People/img/large/Steven_Haddock-1.jpg": 86268,
	"./assets/years/2024/People/img/large/Steven_Haddock.jpg": 35070,
	"./assets/years/2024/People/img/large/Unknown.jpg": 95940,
	"./assets/years/2024/People/img/large/Valentina_Pedoia.jpg": 6105,
	"./assets/years/2024/People/img/large/Wesley_Legant.jpg": 13227,
	"./assets/years/2024/People/organizers": 54939,
	"./assets/years/2024/People/organizers.json": 54939,
	"./assets/years/2024/People/session-chairs": 6364,
	"./assets/years/2024/People/session-chairs.json": 6364,
	"./assets/years/2024/People/slides/Alison_Young.pdf": 58701,
	"./assets/years/2024/People/slides/Charlie_Sheehan.pdf": 67151,
	"./assets/years/2024/People/slides/David_Goodsell.pdf": 92142,
	"./assets/years/2024/People/slides/Fiona_Naughton.pdf": 680,
	"./assets/years/2024/People/slides/Jessica_Hullman.pdf": 72256,
	"./assets/years/2024/People/slides/Karen_Miga.pdf": 58340,
	"./assets/years/2024/People/slides/Martin_Krzywinski.pdf": 28965,
	"./assets/years/2024/People/slides/Matthew_Taliaferro.pdf": 21708,
	"./assets/years/2024/People/slides/Rachel_Meyer.pdf": 2434,
	"./assets/years/2024/People/speakers": 12723,
	"./assets/years/2024/People/speakers.json": 12723,
	"./assets/years/2024/Posters/Index": 52513,
	"./assets/years/2024/Posters/Index.vue": 52513,
	"./assets/years/2024/Program/Index": 67312,
	"./assets/years/2024/Program/Index.vue": 67312,
	"./assets/years/2024/Program/program": 80650,
	"./assets/years/2024/Program/program.json": 80650,
	"./assets/years/2024/Registration/Form/Index": 32611,
	"./assets/years/2024/Registration/Form/Index.vue": 32611,
	"./assets/years/2024/Registration/Index": 35852,
	"./assets/years/2024/Registration/Index.vue": 35852,
	"./assets/years/2024/Registration/events": 19002,
	"./assets/years/2024/Registration/events-reduced": 23225,
	"./assets/years/2024/Registration/events-reduced.json": 23225,
	"./assets/years/2024/Registration/events.json": 19002,
	"./assets/years/2024/Registration/table": 71905,
	"./assets/years/2024/Registration/table-early-bird": 48572,
	"./assets/years/2024/Registration/table-early-bird.vue": 48572,
	"./assets/years/2024/Registration/table.vue": 71905,
	"./assets/years/2024/Showcase/Index": 31431,
	"./assets/years/2024/Showcase/Index.vue": 31431,
	"./assets/years/2024/Showcase/img/banner.jpeg": 90369,
	"./assets/years/2024/Showcase/img/innerspace.png": 58972,
	"./assets/years/2024/Showcase/img/innerspace_mask.png": 28345,
	"./assets/years/2024/Sponsors/Index": 3929,
	"./assets/years/2024/Sponsors/Index.vue": 3929,
	"./assets/years/2024/Sponsors/MainSponsor": 30499,
	"./assets/years/2024/Sponsors/MainSponsor.vue": 30499,
	"./assets/years/2024/Sponsors/img/Bridge-lightMode.png": 6749,
	"./assets/years/2024/Sponsors/img/Bridge-short-old.png": 94878,
	"./assets/years/2024/Sponsors/img/Bridge-short.svg": 36340,
	"./assets/years/2024/Sponsors/img/Bridge-small.png": 6437,
	"./assets/years/2024/Sponsors/img/Bridge.png": 49655,
	"./assets/years/2024/Sponsors/img/Bridge.psd": 78523,
	"./assets/years/2024/Sponsors/img/Bridge.svg": 47817,
	"./assets/years/2024/Sponsors/img/DVS-lightMode.png": 15265,
	"./assets/years/2024/Sponsors/img/DVS-transparent.png": 80562,
	"./assets/years/2024/Sponsors/img/DVS.png": 48139,
	"./assets/years/2024/Sponsors/img/EG-lightMode.png": 74138,
	"./assets/years/2024/Sponsors/img/EG-lightMode2.png": 46674,
	"./assets/years/2024/Sponsors/img/EG-lightMode2.svg": 57686,
	"./assets/years/2024/Sponsors/img/EG.png": 85912,
	"./assets/years/2024/Sponsors/img/EG.psd": 2836,
	"./assets/years/2024/Sponsors/img/Eurographics-Logo.svg": 29506,
	"./assets/years/2024/Sponsors/img/ISCB.jpeg": 18304,
	"./assets/years/2024/Sponsors/img/Notes.txt": 22388,
	"./assets/years/2024/Sponsors/img/USC-Bridge-short.png": 41982,
	"./assets/years/2024/Sponsors/img/USC-Bridge-small.pdf": 28058,
	"./assets/years/2024/Sponsors/img/USC-travel-agent.txt": 9941,
	"./assets/years/2024/Sponsors/img/VCC.png": 21266,
	"./assets/years/2024/Sponsors/img/frontiers.png": 97516,
	"./assets/years/2024/Sponsors/img/frontiers.svg": 27784,
	"./assets/years/2024/Sponsors/img/kaust.png": 38534,
	"./assets/years/2024/Venue/Index": 35071,
	"./assets/years/2024/Venue/Index.vue": 35071,
	"./assets/years/2024/Venue/img/img.001.jpeg": 79267,
	"./assets/years/2024/img/Assets/Flyer.pdf": 35393,
	"./assets/years/2024/img/Assets/Hero.pdf": 94169,
	"./assets/years/2024/img/Hero/Background-new.jpg": 47138,
	"./assets/years/2024/img/Hero/Large.jpg": 92622,
	"./assets/years/2024/img/Hero/Medium.jpg": 42094,
	"./assets/years/2024/img/Hero/los-angeles+credit.jpg": 37925,
	"./assets/years/2024/img/Hero/los-angeles.jpg": 2389,
	"./assets/years/2025/Contact/Index": 54546,
	"./assets/years/2025/Contact/Index.vue": 54546,
	"./assets/years/2025/Index": 33757,
	"./assets/years/2025/Index copy": 81694,
	"./assets/years/2025/Index copy.vue": 81694,
	"./assets/years/2025/Index.vue": 33757,
	"./assets/years/2025/Masterclass/Index": 17937,
	"./assets/years/2025/Masterclass/Index.vue": 17937,
	"./assets/years/2025/Masterclass/links": 37538,
	"./assets/years/2025/Masterclass/links.json": 37538,
	"./assets/years/2025/People/Index": 13528,
	"./assets/years/2025/People/Index.vue": 13528,
	"./assets/years/2025/People/img/Andrew_Carter.png": 9536,
	"./assets/years/2025/People/img/Andy_Lomas copy.png": 90149,
	"./assets/years/2025/People/img/Andy_Lomas.png": 73536,
	"./assets/years/2025/People/img/Andy_Yates.png": 74674,
	"./assets/years/2025/People/img/Barbora_Kozlíková.png": 11393,
	"./assets/years/2025/People/img/Beata_Edyta_Mierzwa.png": 4698,
	"./assets/years/2025/People/img/Blake_Sweeney.png": 15907,
	"./assets/years/2025/People/img/Christian_Stolte.png": 40604,
	"./assets/years/2025/People/img/Cibele_Sotero-Caio.png": 70829,
	"./assets/years/2025/People/img/Daniel_Haehn.png": 36689,
	"./assets/years/2025/People/img/Drew_Berry.png": 18630,
	"./assets/years/2025/People/img/Ewa_Paluch.png": 21252,
	"./assets/years/2025/People/img/Ferdos_Abid_Ali.png": 12164,
	"./assets/years/2025/People/img/Francesca_Ciccarelli.png": 7347,
	"./assets/years/2025/People/img/Gesine_Müller.png": 54937,
	"./assets/years/2025/People/img/Irmtraud_Meyer.png": 16464,
	"./assets/years/2025/People/img/Jaime_Huerta-Cepas.png": 61110,
	"./assets/years/2025/People/img/Jaime_Huerta-Cepas.webp": 56639,
	"./assets/years/2025/People/img/James_Procter.png": 98877,
	"./assets/years/2025/People/img/Janina_Wellmann.png": 92945,
	"./assets/years/2025/People/img/Jason_Swedlow.png": 10328,
	"./assets/years/2025/People/img/Jessica_Xin_Hjaltelin.png": 60875,
	"./assets/years/2025/People/img/Jonathan_Wood.png": 6904,
	"./assets/years/2025/People/img/Jörg_Hagmann.png": 2755,
	"./assets/years/2025/People/img/Laura_Garrison.png": 18098,
	"./assets/years/2025/People/img/Lawrence_Hunter.png": 90553,
	"./assets/years/2025/People/img/Leonora_Martínez-Núñez.png": 10959,
	"./assets/years/2025/People/img/Lina_Kim.png": 87371,
	"./assets/years/2025/People/img/Marc_Streit.png": 99854,
	"./assets/years/2025/People/img/Martin_Krzywinski.png": 59720,
	"./assets/years/2025/People/img/Meghna_Swayambhu.png": 26529,
	"./assets/years/2025/People/img/Nico_Scherf.png": 41370,
	"./assets/years/2025/People/img/Panagiotis_Kastritis.png": 81322,
	"./assets/years/2025/People/img/Paula_Murphy.png": 56590,
	"./assets/years/2025/People/img/Peijun_Zhang.png": 60631,
	"./assets/years/2025/People/img/Robert_Finn.jpg": 41209,
	"./assets/years/2025/People/img/Robert_Finn.png": 39297,
	"./assets/years/2025/People/img/Rommie_Amaro.jpg": 84799,
	"./assets/years/2025/People/img/Rommie_E._Amaro.png": 53655,
	"./assets/years/2025/People/img/Samuel_Flores.png": 11748,
	"./assets/years/2025/People/img/Sarah_Marzi.png": 68270,
	"./assets/years/2025/People/img/Seán_O'Donoghue.png": 8654,
	"./assets/years/2025/People/img/Sofie_Louise_Valk.png": 75466,
	"./assets/years/2025/People/img/Sofie_Louise_Valk.webp": 28155,
	"./assets/years/2025/People/img/Theodoros_Soldatos.png": 74514,
	"./assets/years/2025/People/img/Tobias_Isenberg.png": 70301,
	"./assets/years/2025/People/img/Unknown.png": 87731,
	"./assets/years/2025/People/img/Wolfram_Pönisch.png": 80701,
	"./assets/years/2025/People/img/Wolfram_Pönisch_old.png": 73691,
	"./assets/years/2025/People/img/Yann_Ponty.png": 60660,
	"./assets/years/2025/People/img/large/Andy_Lomas.jpg": 60800,
	"./assets/years/2025/People/img/large/Barbora_Kozlíková.jpg": 67173,
	"./assets/years/2025/People/img/large/Beata_Edyta_Mierzwa.jpg": 76002,
	"./assets/years/2025/People/img/large/Blake_Sweeney.jpg": 33839,
	"./assets/years/2025/People/img/large/Christian_Stolte.jpg": 67028,
	"./assets/years/2025/People/img/large/Cibele_Sotero-Caio.jpg": 697,
	"./assets/years/2025/People/img/large/Daniel_Haehn.jpg": 55725,
	"./assets/years/2025/People/img/large/Drew_Berry.jpg": 81206,
	"./assets/years/2025/People/img/large/Ferdos_Abid_Ali.jpg": 18452,
	"./assets/years/2025/People/img/large/Francesca_Ciccarelli.jpg": 8383,
	"./assets/years/2025/People/img/large/Gesine_Müller.jpg": 19285,
	"./assets/years/2025/People/img/large/Jaime_Huerta-Cepas.jpg": 61438,
	"./assets/years/2025/People/img/large/James_Procter.jpg": 81889,
	"./assets/years/2025/People/img/large/Janina_Wellmann.jpg": 62125,
	"./assets/years/2025/People/img/large/Jessica_Xin_Hjaltelin.jpg": 85631,
	"./assets/years/2025/People/img/large/Jonathan_Wood.jpg": 69112,
	"./assets/years/2025/People/img/large/Laura_Garrison.jpg": 68802,
	"./assets/years/2025/People/img/large/Lina_Kim.jpg": 63583,
	"./assets/years/2025/People/img/large/Marc_Streit.jpg": 99734,
	"./assets/years/2025/People/img/large/Meghna_Swayambhu.jpg": 25701,
	"./assets/years/2025/People/img/large/Panagiotis_Kastritis-old.jpg": 53141,
	"./assets/years/2025/People/img/large/Panagiotis_Kastritis-old.png": 32165,
	"./assets/years/2025/People/img/large/Panagiotis_Kastritis.jpg": 81217,
	"./assets/years/2025/People/img/large/Paula_Murphy.jpg": 82878,
	"./assets/years/2025/People/img/large/Samuel_Flores-old.jpg": 23988,
	"./assets/years/2025/People/img/large/Samuel_Flores.jpg": 34124,
	"./assets/years/2025/People/img/large/Sarah_Marzi.jpg": 11838,
	"./assets/years/2025/People/img/large/Seán_O'Donoghue.jpg": 20894,
	"./assets/years/2025/People/img/large/Sofie_Louise_Valk.jpg": 23754,
	"./assets/years/2025/People/img/large/Tobias_Isenberg.jpg": 29305,
	"./assets/years/2025/People/img/large/Unknown.png": 83151,
	"./assets/years/2025/People/img/large/Wolfram_Pönisch.jpg": 43585,
	"./assets/years/2025/People/img/large/Wolfram_Pönisch_old.jpg": 9431,
	"./assets/years/2025/People/img/large/Yann_Ponty.jpg": 97612,
	"./assets/years/2025/People/img/large/enhanced/Andrew_Carter.png": 51239,
	"./assets/years/2025/People/img/large/enhanced/Blake_Sweeney.png": 84740,
	"./assets/years/2025/People/img/large/enhanced/Cibele_Sotero-Caio.png": 23924,
	"./assets/years/2025/People/img/large/enhanced/Drew_Berry-source.jpeg": 84414,
	"./assets/years/2025/People/img/large/enhanced/Drew_Berry.png": 74199,
	"./assets/years/2025/People/img/large/enhanced/Ewa_Paluch.png": 77505,
	"./assets/years/2025/People/img/large/enhanced/Ferdos_Abid_Ali copy.png": 74032,
	"./assets/years/2025/People/img/large/enhanced/Ferdos_Abid_Ali.png": 42551,
	"./assets/years/2025/People/img/large/enhanced/Francesca_Ciccarelli.png": 9178,
	"./assets/years/2025/People/img/large/enhanced/Gesine_Mueller.png": 5200,
	"./assets/years/2025/People/img/large/enhanced/Irmtraud_Meyer.png": 8445,
	"./assets/years/2025/People/img/large/enhanced/Jaime_Huerta-Cepas.png": 51615,
	"./assets/years/2025/People/img/large/enhanced/James_Procter.png": 71130,
	"./assets/years/2025/People/img/large/enhanced/Janina_Wellmann.png": 98066,
	"./assets/years/2025/People/img/large/enhanced/Jessica_Xin_Hjaltelin.png": 82572,
	"./assets/years/2025/People/img/large/enhanced/Jonathan_Wood.png": 36771,
	"./assets/years/2025/People/img/large/enhanced/Jörg_Hagmann.png": 48642,
	"./assets/years/2025/People/img/large/enhanced/Marc_Streit copy.png": 91574,
	"./assets/years/2025/People/img/large/enhanced/Marc_Streit.jpg": 34793,
	"./assets/years/2025/People/img/large/enhanced/Marc_Streit.png": 62609,
	"./assets/years/2025/People/img/large/enhanced/Meghna_Swayambhu copy.jpg": 26577,
	"./assets/years/2025/People/img/large/enhanced/Meghna_Swayambhu.jpg": 44864,
	"./assets/years/2025/People/img/large/enhanced/Panagiotis_Kastritis.png": 23244,
	"./assets/years/2025/People/img/large/enhanced/Paula_Murphy.jpg": 48659,
	"./assets/years/2025/People/img/large/enhanced/Peijun_Zhang.png": 35910,
	"./assets/years/2025/People/img/large/enhanced/Robert_Finn.png": 58294,
	"./assets/years/2025/People/img/large/enhanced/Rommie_E._Amaro.jpg": 97380,
	"./assets/years/2025/People/img/large/enhanced/Samuel_Flores-old.png": 11175,
	"./assets/years/2025/People/img/large/enhanced/Samuel_Flores.jpeg": 28264,
	"./assets/years/2025/People/img/large/enhanced/Sofie_Louise_Valk copy.png": 33126,
	"./assets/years/2025/People/img/large/enhanced/Sofie_Louise_Valk.png": 84705,
	"./assets/years/2025/People/img/large/enhanced/Tobias_Isenberg.jpg": 80986,
	"./assets/years/2025/People/img/large/enhanced/Tobias_Isenberg.png": 44958,
	"./assets/years/2025/People/img/large/enhanced/Wolfram_Pönisch.png": 82914,
	"./assets/years/2025/People/img/large/enhanced/Yann_Ponty.png": 58209,
	"./assets/years/2025/People/img/large/enhanced/leonora foto.jpg": 1040,
	"./assets/years/2025/People/organizers": 58652,
	"./assets/years/2025/People/organizers.json": 58652,
	"./assets/years/2025/People/session-chairs": 49887,
	"./assets/years/2025/People/session-chairs.json": 49887,
	"./assets/years/2025/People/slides/Andy_Lomas.pdf": 80806,
	"./assets/years/2025/People/slides/Barbora_Kozlíková.pdf": 63741,
	"./assets/years/2025/People/slides/Blake_Sweeney.pdf": 25667,
	"./assets/years/2025/People/slides/Christian_Stolte.pdf": 12286,
	"./assets/years/2025/People/slides/Daniel_Haehn.pdf": 2375,
	"./assets/years/2025/People/slides/Gesine_Müller.pdf": 15797,
	"./assets/years/2025/People/slides/Sarah_Marzi.pdf": 41238,
	"./assets/years/2025/People/slides/Tobias_Isenberg.pdf": 9553,
	"./assets/years/2025/People/speakers": 97432,
	"./assets/years/2025/People/speakers.json": 97432,
	"./assets/years/2025/Posters/Index": 71210,
	"./assets/years/2025/Posters/Index.vue": 71210,
	"./assets/years/2025/Program/Index": 31096,
	"./assets/years/2025/Program/Index.vue": 31096,
	"./assets/years/2025/Program/program": 61669,
	"./assets/years/2025/Program/program.json": 61669,
	"./assets/years/2025/Registration/Form/Index": 86846,
	"./assets/years/2025/Registration/Form/Index.vue": 86846,
	"./assets/years/2025/Registration/Index": 29040,
	"./assets/years/2025/Registration/Index.vue": 29040,
	"./assets/years/2025/Registration/abbreviations": 55021,
	"./assets/years/2025/Registration/abbreviations.json": 55021,
	"./assets/years/2025/Registration/discounts": 34532,
	"./assets/years/2025/Registration/discounts.json": 34532,
	"./assets/years/2025/Registration/events": 48641,
	"./assets/years/2025/Registration/events-reduced": 2834,
	"./assets/years/2025/Registration/events-reduced.json": 2834,
	"./assets/years/2025/Registration/events.json": 48641,
	"./assets/years/2025/Registration/table": 26128,
	"./assets/years/2025/Registration/table-early-bird": 30186,
	"./assets/years/2025/Registration/table-early-bird.vue": 30186,
	"./assets/years/2025/Registration/table.vue": 26128,
	"./assets/years/2025/Showcase/Index": 91529,
	"./assets/years/2025/Showcase/Index.vue": 91529,
	"./assets/years/2025/Showcase/img/banner.jpeg": 29866,
	"./assets/years/2025/Showcase/img/innerspace.png": 78029,
	"./assets/years/2025/Showcase/img/innerspace_mask.png": 39970,
	"./assets/years/2025/Sponsors/Index": 19261,
	"./assets/years/2025/Sponsors/Index.vue": 19261,
	"./assets/years/2025/Sponsors/MainSponsor": 8254,
	"./assets/years/2025/Sponsors/MainSponsor.vue": 8254,
	"./assets/years/2025/Sponsors/img/CoB-lightMode.svg": 42427,
	"./assets/years/2025/Sponsors/img/CoB.svg": 52749,
	"./assets/years/2025/Sponsors/img/DVS-lightMode.png": 94858,
	"./assets/years/2025/Sponsors/img/DVS-transparent.png": 79273,
	"./assets/years/2025/Sponsors/img/DVS.png": 74139,
	"./assets/years/2025/Sponsors/img/EG-lightMode.png": 92339,
	"./assets/years/2025/Sponsors/img/EG-lightMode2.png": 49225,
	"./assets/years/2025/Sponsors/img/EG-lightMode2.svg": 48789,
	"./assets/years/2025/Sponsors/img/EG.png": 60253,
	"./assets/years/2025/Sponsors/img/EG.psd": 17589,
	"./assets/years/2025/Sponsors/img/Eurographics-Logo.svg": 20445,
	"./assets/years/2025/Sponsors/img/ISCB.jpeg": 99803,
	"./assets/years/2025/Sponsors/img/Magdalene.jpg": 29899,
	"./assets/years/2025/Sponsors/img/Magdalene.png": 32595,
	"./assets/years/2025/Sponsors/img/Magdalene.svg": 67023,
	"./assets/years/2025/Sponsors/img/Magdalene_precise_background.jpeg": 72363,
	"./assets/years/2025/Sponsors/img/Magdalene_precise_background.svg": 92496,
	"./assets/years/2025/Sponsors/img/Notes.txt": 20267,
	"./assets/years/2025/Sponsors/img/USC-Bridge-short.png": 25859,
	"./assets/years/2025/Sponsors/img/USC-Bridge-small.pdf": 54267,
	"./assets/years/2025/Sponsors/img/USC-travel-agent.txt": 42436,
	"./assets/years/2025/Sponsors/img/VCC.png": 89185,
	"./assets/years/2025/Sponsors/img/biovis-lightMode.svg": 71629,
	"./assets/years/2025/Sponsors/img/biovis-white.svg": 34687,
	"./assets/years/2025/Sponsors/img/biovis.png": 58185,
	"./assets/years/2025/Sponsors/img/biovis.svg": 75855,
	"./assets/years/2025/Sponsors/img/frontiers-lightMode.svg": 66849,
	"./assets/years/2025/Sponsors/img/frontiers.png": 48527,
	"./assets/years/2025/Sponsors/img/frontiers.svg": 49219,
	"./assets/years/2025/Sponsors/img/kaust.png": 90413,
	"./assets/years/2025/Venue/Index": 78652,
	"./assets/years/2025/Venue/Index.vue": 78652,
	"./assets/years/2025/Venue/img/auditorium.jpg": 18036,
	"./assets/years/2025/Venue/img/college_map.pdf": 61478,
	"./assets/years/2025/Venue/img/formal-hall.jpg": 42962,
	"./assets/years/2025/Venue/img/magdalene.jpg": 66303,
	"./assets/years/2025/Venue/img/river.jpg": 62223,
	"./assets/years/2025/img/Assets/Flyer.pdf": 27862,
	"./assets/years/2025/img/Assets/Hero.pdf": 56560,
	"./assets/years/2025/img/Hero/Background-new.jpg": 60471,
	"./assets/years/2025/img/Hero/Medium.jpg": 95211,
	"./assets/years/2025/img/Hero/Original copy.png": 24440,
	"./assets/years/2025/img/Hero/Original.png": 42575,
	"./assets/years/2025/img/Hero/Standard.png": 44689,
	"./assets/years/2025/keyDates": 65182,
	"./assets/years/2025/keyDates.json": 65182,
	"./components/AddTweets": 48979,
	"./components/AddTweets.vue": 48979,
	"./components/App/ButtonRow": 24516,
	"./components/App/ButtonRow.vue": 24516,
	"./components/App/CloseButton": 35845,
	"./components/App/CloseButton.vue": 35845,
	"./components/App/Json": 39931,
	"./components/App/Json.vue": 39931,
	"./components/App/Pronounced": 84142,
	"./components/App/Pronounced.vue": 84142,
	"./components/App/Slider": 813,
	"./components/App/Slider.vue": 813,
	"./components/App/Sound": 69083,
	"./components/App/Sound.vue": 69083,
	"./components/App/Table": 88411,
	"./components/App/Table.vue": 88411,
	"./components/ButtonBase": 3562,
	"./components/ButtonBase.vue": 3562,
	"./components/ButtonBespoke": 31776,
	"./components/ButtonBespoke.vue": 31776,
	"./components/ButtonMail": 27275,
	"./components/ButtonMail.vue": 27275,
	"./components/CallToAction/Banner": 71814,
	"./components/CallToAction/Banner.vue": 71814,
	"./components/CallToAction/PreRegisterNow": 467,
	"./components/CallToAction/PreRegisterNow.vue": 467,
	"./components/CallToAction/RegisterNow": 66146,
	"./components/CallToAction/RegisterNow.vue": 66146,
	"./components/CallToAction/RegisterNowWrapper": 62287,
	"./components/CallToAction/RegisterNowWrapper.vue": 62287,
	"./components/CallToAction/StayUpdated": 98669,
	"./components/CallToAction/StayUpdated.vue": 98669,
	"./components/CallToAction/Timer": 91921,
	"./components/CallToAction/Timer.vue": 91921,
	"./components/Countdown": 4402,
	"./components/Countdown-old": 796,
	"./components/Countdown-old.vue": 796,
	"./components/Countdown.vue": 4402,
	"./components/DialogModal": 63689,
	"./components/DialogModal.vue": 63689,
	"./components/Dropdown": 33898,
	"./components/Dropdown.vue": 33898,
	"./components/Dropdown/Dropdown": 17073,
	"./components/Dropdown/Dropdown.vue": 17073,
	"./components/Dropdown/DropdownItem": 76390,
	"./components/Dropdown/DropdownItem.vue": 76390,
	"./components/Dropdown/DropdownItemOld": 7147,
	"./components/Dropdown/DropdownItemOld.vue": 7147,
	"./components/Dropdown/DropdownMenu": 85138,
	"./components/Dropdown/DropdownMenu.vue": 85138,
	"./components/DropdownRoutes/Dropdown": 28255,
	"./components/DropdownRoutes/Dropdown.vue": 28255,
	"./components/DropdownRoutes/DropdownItem": 24200,
	"./components/DropdownRoutes/DropdownItem.vue": 24200,
	"./components/DropdownRoutes/DropdownItemOld": 70036,
	"./components/DropdownRoutes/DropdownItemOld.vue": 70036,
	"./components/DropdownRoutes/DropdownMenu": 20232,
	"./components/DropdownRoutes/DropdownMenu.vue": 20232,
	"./components/Email": 82749,
	"./components/Email.vue": 82749,
	"./components/EmailEncoder": 17618,
	"./components/EmailEncoder.vue": 17618,
	"./components/EventItem": 13792,
	"./components/EventItem.vue": 13792,
	"./components/GdprConsent": 7394,
	"./components/GdprConsent.vue": 7394,
	"./components/Header": 53784,
	"./components/Header.vue": 53784,
	"./components/HeroCredits": 41636,
	"./components/HeroCredits.vue": 41636,
	"./components/HeroImage": 83172,
	"./components/HeroImage.vue": 83172,
	"./components/HeroVideo": 40004,
	"./components/HeroVideo.vue": 40004,
	"./components/HeroVideoVimeo": 26553,
	"./components/HeroVideoVimeo.vue": 26553,
	"./components/Iscb": 92070,
	"./components/Iscb.vue": 92070,
	"./components/KeyDates": 94821,
	"./components/KeyDates.vue": 94821,
	"./components/LiveEvent": 75605,
	"./components/LiveEvent.vue": 75605,
	"./components/LoadingNextPage": 32134,
	"./components/LoadingNextPage.vue": 32134,
	"./components/Logo": 16751,
	"./components/Logo.vue": 16751,
	"./components/Logo3D": 10055,
	"./components/Logo3D.vue": 10055,
	"./components/MainSponsors": 27799,
	"./components/MainSponsors.vue": 27799,
	"./components/MaskedVideo": 85990,
	"./components/MaskedVideo.vue": 85990,
	"./components/ModalDialog/ContactUs": 36356,
	"./components/ModalDialog/ContactUs.vue": 36356,
	"./components/ModalDialog/Index": 45422,
	"./components/ModalDialog/Index.vue": 45422,
	"./components/ModalDialog/IndexOld": 2891,
	"./components/ModalDialog/IndexOld.vue": 2891,
	"./components/ModalDialog/JoinMeeting": 82361,
	"./components/ModalDialog/JoinMeeting.vue": 82361,
	"./components/ModalDialog/Maintenance": 86275,
	"./components/ModalDialog/Maintenance.vue": 86275,
	"./components/ModalDialog/PreRegister": 85107,
	"./components/ModalDialog/PreRegister.vue": 85107,
	"./components/ModalDialog/PreRegisterNew": 99224,
	"./components/ModalDialog/PreRegisterNew.vue": 99224,
	"./components/ModalDialog/StayUpdated": 28381,
	"./components/ModalDialog/StayUpdated.vue": 28381,
	"./components/Navigation/Archive": 42211,
	"./components/Navigation/Archive.vue": 42211,
	"./components/Navigation/Archive/Dropdown": 72694,
	"./components/Navigation/Archive/Dropdown.vue": 72694,
	"./components/Navigation/Archive/Grid": 96700,
	"./components/Navigation/Archive/Grid.vue": 96700,
	"./components/Navigation/Archive/Menu": 3808,
	"./components/Navigation/Archive/Menu.vue": 3808,
	"./components/Navigation/Burger": 71913,
	"./components/Navigation/Burger.vue": 71913,
	"./components/Navigation/Photos": 68961,
	"./components/Navigation/Photos.vue": 68961,
	"./components/Navigation/Primary": 87056,
	"./components/Navigation/Primary.vue": 87056,
	"./components/Navigation/Primary/Dialog": 59074,
	"./components/Navigation/Primary/Dialog.vue": 59074,
	"./components/Navigation/Primary/Item": 8345,
	"./components/Navigation/Primary/Item.vue": 8345,
	"./components/Navigation/Primary/Menu": 68447,
	"./components/Navigation/Primary/Menu.vue": 68447,
	"./components/Navigation/Secondary": 67391,
	"./components/Navigation/Secondary.vue": 67391,
	"./components/NotFound": 41723,
	"./components/NotFound.vue": 41723,
	"./components/People/Gallery": 49807,
	"./components/People/Gallery.vue": 49807,
	"./components/People/Person": 31142,
	"./components/People/Person.vue": 31142,
	"./components/People/Person/Headshot": 70795,
	"./components/People/Person/Headshot.vue": 70795,
	"./components/People/Person/Highlight": 307,
	"./components/People/Person/Highlight-not-so-old": 1521,
	"./components/People/Person/Highlight-not-so-old.vue": 1521,
	"./components/People/Person/Highlight-old": 89928,
	"./components/People/Person/Highlight-old.vue": 89928,
	"./components/People/Person/Highlight.vue": 307,
	"./components/People/Person/Slides": 56088,
	"./components/People/Person/Slides-signIn": 3279,
	"./components/People/Person/Slides-signIn.vue": 3279,
	"./components/People/Person/Slides.vue": 56088,
	"./components/People/Person/TagList": 9184,
	"./components/People/Person/TagList.vue": 9184,
	"./components/People/Person/Topic": 79031,
	"./components/People/Person/Topic.vue": 79031,
	"./components/Photo": 56608,
	"./components/Photo.vue": 56608,
	"./components/PhotoHighlight": 87383,
	"./components/PhotoHighlight.vue": 87383,
	"./components/PhotoHighlightState": 20169,
	"./components/PhotoHighlightState.vue": 20169,
	"./components/Popup/Warning": 99149,
	"./components/Popup/Warning.vue": 99149,
	"./components/PosterUploadForm": 68648,
	"./components/PosterUploadForm.vue": 68648,
	"./components/Program/DayTags": 71679,
	"./components/Program/DayTags.vue": 71679,
	"./components/Program/Parse": 12796,
	"./components/Program/Parse.vue": 12796,
	"./components/Program/Table": 17077,
	"./components/Program/Table.vue": 17077,
	"./components/Program/TableRows": 93845,
	"./components/Program/TableRows.vue": 93845,
	"./components/Program/TimeZone": 89826,
	"./components/Program/TimeZone.vue": 89826,
	"./components/Program/VideoIcon": 32069,
	"./components/Program/VideoIcon.vue": 32069,
	"./components/Registration/Calculator": 98467,
	"./components/Registration/Calculator.vue": 98467,
	"./components/Registration/FeeTable": 41939,
	"./components/Registration/FeeTable.vue": 41939,
	"./components/Registration/FeeTableAnimated": 92737,
	"./components/Registration/FeeTableAnimated.vue": 92737,
	"./components/Registration/FeeTableIntermediateValue": 64956,
	"./components/Registration/FeeTableIntermediateValue.vue": 64956,
	"./components/RegistrationFee": 21488,
	"./components/RegistrationFee.vue": 21488,
	"./components/ReplaceTweets": 8014,
	"./components/ReplaceTweets.vue": 8014,
	"./components/SearchBox": 15630,
	"./components/SearchBox.vue": 15630,
	"./components/SearchPage": 54592,
	"./components/SearchPage.vue": 54592,
	"./components/SignIn": 32233,
	"./components/SignIn-old": 32897,
	"./components/SignIn-old.vue": 32897,
	"./components/SignIn.vue": 32233,
	"./components/Spill": 21620,
	"./components/Spill.vue": 21620,
	"./components/Subtitle": 35869,
	"./components/Subtitle.vue": 35869,
	"./components/SubtitleSVG": 47163,
	"./components/SubtitleSVG.vue": 47163,
	"./components/SwitchBespoke": 95335,
	"./components/SwitchBespoke.vue": 95335,
	"./components/Tag": 54099,
	"./components/Tag.vue": 54099,
	"./components/TimeZone": 78732,
	"./components/TimeZone.vue": 78732,
	"./components/TwitterFeed": 73539,
	"./components/TwitterFeed.vue": 73539,
	"./components/VideoBespoke": 39633,
	"./components/VideoBespoke copy": 51604,
	"./components/VideoBespoke copy.vue": 51604,
	"./components/VideoBespoke.vue": 39633,
	"./components/VideoGallery": 25202,
	"./components/VideoGallery.vue": 25202,
	"./components/VideoGalleryItem": 99014,
	"./components/VideoGalleryItem.vue": 99014,
	"./components/VideoLegend": 72773,
	"./components/VideoLegend.vue": 72773,
	"./components/VideoLink": 96747,
	"./components/VideoLink.vue": 96747,
	"./components/VideoLinkOld": 64791,
	"./components/VideoLinkOld.vue": 64791,
	"./components/Zoom": 67968,
	"./components/Zoom-old": 44841,
	"./components/Zoom-old.vue": 44841,
	"./components/Zoom.vue": 67968,
	"./composables/SignIn/SignIn2": 62767,
	"./composables/SignIn/SignIn2.js": 62767,
	"./composables/SignIn/call_the_backend_api": 6315,
	"./composables/SignIn/call_the_backend_api.js": 6315,
	"./composables/SignIn/check_the_response": 8061,
	"./composables/SignIn/check_the_response.js": 8061,
	"./composables/currentYearPast": 45276,
	"./composables/currentYearPast.js": 45276,
	"./composables/test": 13250,
	"./composables/test.js": 13250,
	"./composables/tests/Test-require": 62188,
	"./composables/tests/Test-require.vue": 62188,
	"./composables/tests/index.html": 19336,
	"./composables/tests/quokka-basics": 85008,
	"./composables/tests/quokka-import": 58846,
	"./composables/tests/script": 36187,
	"./composables/tests/script.js": 36187,
	"./composables/tests/test": 3796,
	"./composables/tests/test.js": 3796,
	"./composables/tests/useRequire": 31422,
	"./composables/tests/useRequire.js": 31422,
	"./composables/tests/useRouteTest": 42324,
	"./composables/tests/useRouteTest-copy": 65232,
	"./composables/tests/useRouteTest-copy.js": 65232,
	"./composables/tests/useRouteTest.js": 42324,
	"./composables/useArrayMerge": 45172,
	"./composables/useArrayMerge.js": 45172,
	"./composables/useArrayMergeAsync": 16834,
	"./composables/useArrayMergeAsync.js": 16834,
	"./composables/useBackground": 98171,
	"./composables/useBackground.js": 98171,
	"./composables/useDataAnimation": 27033,
	"./composables/useDataAnimation.js": 27033,
	"./composables/useDataTransition": 6016,
	"./composables/useDataTransition.js": 6016,
	"./composables/useDiscounts": 67247,
	"./composables/useDiscounts.js": 67247,
	"./composables/useDisplayMode": 82006,
	"./composables/useDisplayMode.js": 82006,
	"./composables/useDisplayWidth": 39981,
	"./composables/useDisplayWidth.js": 39981,
	"./composables/useFlickrGetInfo": 32994,
	"./composables/useFlickrGetInfo.js": 32994,
	"./composables/useFlickrSearch": 75524,
	"./composables/useFlickrSearch.js": 75524,
	"./composables/useFlickrSearchData": 96428,
	"./composables/useFlickrSearchData.js": 96428,
	"./composables/useFocusHandlers": 62686,
	"./composables/useFocusHandlers.js": 62686,
	"./composables/useIsSignedIn": 74508,
	"./composables/useIsSignedIn.js": 74508,
	"./composables/useKeepScrollPosition": 95000,
	"./composables/useKeepScrollPosition.js": 95000,
	"./composables/useMaxFontSize": 4529,
	"./composables/useMaxFontSize.js": 4529,
	"./composables/useObjectMerge": 19833,
	"./composables/useObjectMerge.js": 19833,
	"./composables/useObjectMergeAsync": 91260,
	"./composables/useObjectMergeAsync.js": 91260,
	"./composables/useObservers": 92112,
	"./composables/useObservers.js": 92112,
	"./composables/useProgram": 73451,
	"./composables/useProgram copy": 56442,
	"./composables/useProgram copy.js": 56442,
	"./composables/useProgram.js": 73451,
	"./composables/useRegionalDiscount": 41397,
	"./composables/useRegionalDiscount.js": 41397,
	"./composables/useSelectedYear": 95239,
	"./composables/useSelectedYear-new": 5996,
	"./composables/useSelectedYear-new.js": 5996,
	"./composables/useSelectedYear.js": 95239,
	"./composables/useSetUrlHash": 75286,
	"./composables/useSetUrlHash.js": 75286,
	"./composables/useShort": 62069,
	"./composables/useShort.js": 62069,
	"./composables/useShowEvents": 46335,
	"./composables/useShowEvents.js": 46335,
	"./composables/useTense": 96520,
	"./composables/useTense.js": 96520,
	"./composables/useVizbiOrder": 28735,
	"./composables/useVizbiOrder.js": 28735,
	"./composables/useWaitForRef": 21450,
	"./composables/useWaitForRef.js": 21450,
	"./main": 40480,
	"./main.js": 40480,
	"./plugins/meta-pixel": 95476,
	"./plugins/meta-pixel.js": 95476,
	"./router": 21439,
	"./router/": 21439,
	"./router/index": 21439,
	"./router/index.js": 21439,
	"./store": 4111,
	"./store/": 4111,
	"./store/index": 4111,
	"./store/index.js": 4111,
	"./styles/global.css": 38903,
	"./styles/show-hide-curtain.css": 49721,
	"./styles/show-hide-stage.css": 59181,
	"./views/About": 65742,
	"./views/About.vue": 65742,
	"./views/Admin": 43303,
	"./views/Admin.vue": 43303,
	"./views/Blog": 58091,
	"./views/Blog.vue": 58091,
	"./views/Live": 91632,
	"./views/Live-2024": 13657,
	"./views/Live-2024.vue": 13657,
	"./views/Live-NotSoOld": 70887,
	"./views/Live-NotSoOld.vue": 70887,
	"./views/Live-old": 9107,
	"./views/Live-old.vue": 9107,
	"./views/Live.vue": 91632,
	"./views/Mail": 25582,
	"./views/Mail.vue": 25582,
	"./views/Photos": 9361,
	"./views/Photos.vue": 9361,
	"./views/Posters/Index": 85384,
	"./views/Posters/Index.vue": 85384,
	"./views/Posters/Upload": 22677,
	"./views/Posters/Upload.vue": 22677,
	"./views/Public": 25444,
	"./views/Public.vue": 25444,
	"./views/SignUp": 2965,
	"./views/SignUp.vue": 2965,
	"./views/Terms": 2833,
	"./views/Terms.vue": 2833,
	"./views/Test": 82311,
	"./views/Test.vue": 82311,
	"./views/Videos": 68445,
	"./views/Videos.vue": 68445,
	"./views/Year/About": 27810,
	"./views/Year/About.vue": 27810,
	"./views/Year/Contact": 30462,
	"./views/Year/Contact.vue": 30462,
	"./views/Year/Form": 23186,
	"./views/Year/Form.vue": 23186,
	"./views/Year/Index": 60196,
	"./views/Year/Index.vue": 60196,
	"./views/Year/Masterclass": 32946,
	"./views/Year/Masterclass.vue": 32946,
	"./views/Year/People": 31426,
	"./views/Year/People.vue": 31426,
	"./views/Year/Platform": 26171,
	"./views/Year/Platform.vue": 26171,
	"./views/Year/Posters": 50840,
	"./views/Year/Posters.vue": 50840,
	"./views/Year/Program": 66029,
	"./views/Year/Program.vue": 66029,
	"./views/Year/Registration": 74388,
	"./views/Year/Registration.vue": 74388,
	"./views/Year/Showcase": 15589,
	"./views/Year/Showcase.vue": 15589,
	"./views/Year/Sponsors": 55417,
	"./views/Year/Sponsors.vue": 55417,
	"./views/Year/Test": 83614,
	"./views/Year/Test.vue": 83614,
	"./views/Year/VR": 63275,
	"./views/Year/VR.vue": 63275,
	"./views/Year/Venue": 76620,
	"./views/Year/Venue.vue": 76620,
	"./views/Year/Workshop": 11091,
	"./views/Year/Workshop.vue": 11091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;